import { app } from '../../app.module'
app.component('postTagEdit', {
  bindings: {
    snsType: '@',
    postId: '@',
  },
  template: require('./post-tag-edit.pug')(),
})
